import { defineMessages } from 'react-intl'

const scope = 'app.components.UserRole'

export default defineMessages({
  roles: {
    basicUser: {
      id: `${scope}.roles.basicUser`,
      defaultMessage: 'Basic User',
    },
    admin: {
      id: `${scope}.roles.admin`,
      defaultMessage: 'Superuser',
    },
    superuser: {
      id: `${scope}.roles.superuser`,
      defaultMessage: 'Admin',
    },
  },
})
